// components/TelebirrDepositModal.jsx
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TelebirrDepositModal = ({ onClose }) => {
  const [receiptNumber, setReceiptNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCheck = async () => {
    if (!receiptNumber.trim()) {
      toast.error("Please enter your Telebirr receipt number!");
      return;
    }

    setIsLoading(true);

    try {
      // 🔹 Simulated backend call (replace with your actual API)
      const response = await new Promise((resolve) =>
        setTimeout(() => resolve({ success: true }), 2000),
      );
      // const response = await axiosInstance.post("/api/verify-telebirr", {
      //   receiptNumber,
      // });
      if (response.success) {
        toast.success("Transaction verified successfully!");
      } else {
        toast.error("Transaction not found or invalid.");
      }

      //       if (response.data.success) {
      //   toast.success(response.data.message || "Transaction verified successfully!");
      // } else {
      //   toast.error(response.data.message || "Transaction not found or invalid!");
      // }
    } catch (error) {
      toast.error("Error verifying transaction. Try again!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
      <div className="bg-[#0d2d61] text-white rounded-lg shadow-2xl w-[420px] border border-blue-900 relative animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-white text-2xl hover:text-gray-300"
        >
          ✕
        </button>

        {/* Header */}
        <div className="bg-[#10316b] px-4 py-3 rounded-t-lg border-b border-[#1a4a8e] text-center">
          <h2 className="text-lg font-semibold font-serif">
            Telebirr Transfer Deposit
          </h2>
        </div>

        {/* Body */}
        <div className="px-5 py-4 text-[15px] leading-relaxed">
          <p className="text-yellow-400 font-medium mb-2 font-serif">
            ማስገባት የፈለጉትን መጠን ከእርሶ ቴሌብር ወደዚ ስልክ ቁጥር ቴሌብር ትራንስፈር ሲያረጉ ወደ እናት ቢንጎ
            አካውቶ ገቢ ይደረግሎታል
          </p>

          <ol className="list-decimal list-inside text-white space-y-1 mt-2 font-serif">
            <li>Telebirr App ወይም *127# ገብተው</li>
            <li>ስልክ ቁጥሩ ላይ ትራንስፈር ያርጉ</li>
            <li>
              Transaction Checker ውስጥ ገብተው የክፍያ ቁጥር ( Transaction Number ) ቁጥር
              ያስገቡ
            </li>
          </ol>

          {/* Info Box */}
          <div className="bg-white text-[#0d2d61] rounded-md px-4 py-3 mt-4 font-serif">
            <div className="flex justify-between">
              <span className="font-semibold">ስልክ ቁጥር፡</span>
              <span className="font-bold">0943064628</span>
            </div>
            <div className="flex justify-between mt-1">
              <span className="font-semibold">ስም፡</span>
              <span>መንበሩ</span>
            </div>
          </div>

          <p className="text-red-500 text-sm mt-3 text-center font-medium font-serif">
            ትራንስፈር የምታረጉበት ቁጥር ከእናት ቢንጎ አካውቶ ጋር 1 አይነት መሆን አለበት ገቢ የሚደረገሎት እሱ ላይ
            ብቻ ነው
          </p>

          {/* Transaction Input */}
          <div className="bg-[#0a2355] mt-4 p-3 rounded-md border border-[#1a4a8e] font-serif">
            <h3 className="text-white font-semibold text-sm mb-2">
              ውድ ደንበኛችን ዝቅተኛው የገቢ መጠን 100 ብር ነው ከዚ ካነሰ የእናት ቢንጎ Balance Update
              አይደረግላችሁም።
            </h3>
            {/* <label className="block text-sm mb-1">Transaction ቁጥር ያስገቡ</label>
            <input
              type="text"
              value={receiptNumber}
              onChange={(e) => setReceiptNumber(e.target.value)}
              placeholder="Telebirr መልእክት ወይም Receipt ላይ ያገኙታል ለምሳሌ: SB080WSFGH"
              className="w-full px-3 py-2 rounded-md text-gray-900 text-sm focus:outline-none"
            />

           
            <button
              onClick={handleCheck}
              disabled={isLoading}
              className={`w-full mt-4 bg-[#1a4a8e] hover:bg-[#2b5db1] text-white py-2 rounded-md transition font-semibold flex items-center justify-center ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <div className="flex items-center space-x-2">
                  <span className="animate-spin border-2 border-t-transparent border-white rounded-full w-4 h-4"></span>
                  <span>Checking...</span>
                </div>
              ) : (
                "ቼክ ያድርጉ"
              )}
            </button> */}
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default TelebirrDepositModal;
